import { cn } from '@/lib/utils';
import { icons } from 'lucide-react';
import type { MouseEventHandler } from 'react';
import { Link } from 'react-router';

export interface PopoverLinkProps {
  to: string;
  label: string;
  icon?: keyof typeof icons;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

function PopoverLink({
  to,
  label,
  icon,
  className,
  onClick,
}: PopoverLinkProps) {
  const Icon = icon && icons[icon];

  return (
    <Link
      to={to}
      onClick={onClick}
      className={cn(
        'min-w-36 max-w-60 bg-white hover:bg-primary/5 hover:text-primary transition-colors duration-300 text-xs flex gap-2 p-2 rounded-sm',
        className
      )}
    >
      {Icon && <Icon className="size-4" />}
      {label}
    </Link>
  );
}

export { PopoverLink };
